import { render, staticRenderFns } from "./ApiLogs.vue?vue&type=template&id=0413a856"
import script from "./ApiLogs.vue?vue&type=script&lang=js"
export * from "./ApiLogs.vue?vue&type=script&lang=js"
import style0 from "./ApiLogs.vue?vue&type=style&index=0&id=0413a856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports